// Constantes específicas para la cancelación de servicios
export const SERVICE_CANCEL_ENDPOINTS = {
  BASE_PATH: '/api/customer-care/v1',
  CANCEL_SERVICE: '/api/service'
} as const;


export const SERVICE_CANCEL_TIMEOUTS = {
  DEFAULT: 10000, // 10 segundos
  LONG_OPERATION: 30000 // 30 segundos
} as const;

export const SERVICE_CANCEL_CHANNELS = {
  HORUS: 'HORUS',
  GENESYS: 'GENESYS',
  CALL_CENTER: 'CALL_CENTER'
} as const;

export const SERVICE_CANCEL_ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  SERVICE_ERROR: 'SERVICE_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR'
} as const;

export const SERVICE_CANCEL_MESSAGES = {
  VALIDATION_ERROR: 'Datos incompletos para cancelación',
  SERVICE_ERROR: 'Error al cancelar el servicio',
  NETWORK_ERROR: 'No se pudo cancelar el servicio. Intenta nuevamente.',
  TIMEOUT_ERROR: 'La operación tardó demasiado tiempo. Intenta nuevamente.',
  SUCCESS: 'Servicio cancelado exitosamente'
} as const;

export const SERVICE_CANCEL_META = {
  type: '63',
} as const;

// Tipos para mayor type safety
export type ServiceCancelChannel = typeof SERVICE_CANCEL_CHANNELS[keyof typeof SERVICE_CANCEL_CHANNELS];
export type ServiceCancelErrorCode = typeof SERVICE_CANCEL_ERROR_CODES[keyof typeof SERVICE_CANCEL_ERROR_CODES];
